export default __webpack_public_path__ + "static/media/accounting-not-selected.9e97f9b4.png";